// Кнопка-палочка: единственный вход в магию. Держит состояние своего модала
// сама — так её можно поставить в любое место доски, не протаскивая состояние
// через родителя.
import { useState } from 'react';
import { useT } from '../../i18n';
import { MagicModal } from './MagicModal';
import styles from './MagicButton.module.css';

export interface MagicButtonProps {
  /** Дополнительный класс от места, где кнопка стоит (ширина, отступы). */
  className?: string;
}

/** Волшебная палочка: рукоять по диагонали и три искры у кончика. */
function WandIcon() {
  return (
    <svg
      className={styles.icon}
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3.5 20.5 15 9" />
      <path d="m12.5 6.5 5 5" />
      <path d="M19 3v3.4M17.3 4.7h3.4" />
      <path d="M20 13v2.6M18.7 14.3h2.6" />
      <path d="M9 3v2.6M7.7 4.3h2.6" />
    </svg>
  );
}

export function MagicButton({ className }: MagicButtonProps) {
  const t = useT();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`btn ${styles.btn} ${className ?? ''}`}
        title={t('magic.tip')}
        onClick={() => setOpen(true)}
      >
        <WandIcon />
        <span>{t('magic.action')}</span>
      </button>
      <MagicModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
